import gsap from 'gsap';
import { complete } from './shared';
export default function slideDown(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise(function (resolve, reject) {
    var _options$display, _options$ease;

    gsap.killTweensOf(target);

    if (gsap.getProperty(target, 'height') !== 0 && gsap.getProperty(target, 'display') !== 'none') {
      complete(resolve, options);
      return;
    }

    gsap.set(target, {
      display: (_options$display = options === null || options === void 0 ? void 0 : options.display) !== null && _options$display !== void 0 ? _options$display : '',
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      autoAlpha: options.fade ? 0 : undefined,
      overflow: 'hidden'
    });

    if (gsap.getProperty(target, 'display') === 'none') {
      var _options$display2;

      gsap.set(target, {
        display: (_options$display2 = options === null || options === void 0 ? void 0 : options.display) !== null && _options$display2 !== void 0 ? _options$display2 : 'block'
      });
    }

    gsap.to(target, {
      height: 'auto',
      paddingTop: 'auto',
      paddingBottom: 'auto',
      duration: duration,
      ease: (_options$ease = options === null || options === void 0 ? void 0 : options.ease) !== null && _options$ease !== void 0 ? _options$ease : 'power4.out',
      autoAlpha: options.fade ? 1 : undefined,
      delay: options === null || options === void 0 ? void 0 : options.delay,
      stagger: options === null || options === void 0 ? void 0 : options.stagger,
      onStart: function onStart() {
        if (target.parentElement.getAttribute('data-accordion-expanded')) {
          target.parentElement.classList.remove('is-accordion-expanded');
        } else {
          target.parentElement.classList.add('is-accordion-expanded');
        }
      },
      onComplete: function onComplete() {
        gsap.set(target, {
          overflow: ''
        });
        complete(resolve, options);
      },
      onInterrupt: reject
    });
  });
}